import { isValidPhoneNumber } from 'libphonenumber-js';
import * as v from 'valibot';

export const initialValues = {
    gender: undefined,
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: undefined,
    address: {
        street: '',
        postCode: '',
        city: '',
        countryCode: '',
    },
} as Purchaser;

export const phoneNumberSchema = v.object({
    phoneNumber: v.config(
        v.pipe(
            v.string(),
            v.nonEmpty(),
            v.maxLength(50),
            v.trim(),
            v.check((value) => {
                try {
                    return isValidPhoneNumber(value);
                }
                catch {
                    return false;
                }
            }),
        ),
        { message: 'checkout.address.dialog.validationMessages.phoneNumber' },
    ),
});

export const baseSchema = v.object({
    gender: v.config(
        v.picklist(['MALE', 'FEMALE', 'X']),
        { message: 'checkout.address.dialog.validationMessages.gender' },
    ),
    firstName: v.config(
        v.pipe(
            v.string(),
            v.nonEmpty(),
            v.maxLength(255),
            v.trim(),
        ),
        { message: 'checkout.address.dialog.validationMessages.name' },
    ),
    lastName: v.config(
        v.pipe(
            v.string(),
            v.nonEmpty(),
            v.maxLength(255),
            v.trim(),
        ),
        { message: 'checkout.address.dialog.validationMessages.name' },
    ),
    email: v.config(
        v.pipe(
            v.string(),
            v.nonEmpty(),
            v.maxLength(255),
            v.email(),
            v.trim(),
            v.toLowerCase(),

        ),
        { message: 'checkout.address.dialog.validationMessages.email' },
    ),
    address: v.object({
        street: v.config(
            v.pipe(
                v.string(),
                v.nonEmpty(),
                v.maxLength(255),
                v.trim(),
            ),
            { message: 'checkout.address.dialog.validationMessages.street' },
        ),
        postCode: v.config(
            v.pipe(
                v.string(),
                v.nonEmpty(),
                v.maxLength(255),
                v.trim(),
            ),
            { message: 'checkout.address.dialog.validationMessages.postCode' },
        ),
        city: v.config(
            v.pipe(
                v.string(),
                v.nonEmpty(),
                v.maxLength(255),
                v.trim(),
            ),
            { message: 'checkout.address.dialog.validationMessages.city' },
        ),
        countryCode: v.config(
            v.pipe(
                v.string(),
                v.nonEmpty(),
                v.length(2),
                v.trim(),
                v.toUpperCase(),
            ),
            { message: 'checkout.address.dialog.validationMessages.countryCode' },
        ),
    }),
});
